import { render } from "./Fluxo.vue?vue&type=template&id=6d1566e2&scoped=true&ts=true"
import script from "./Fluxo.vue?vue&type=script&lang=ts"
export * from "./Fluxo.vue?vue&type=script&lang=ts"

import "./Fluxo.vue?vue&type=style&index=0&id=6d1566e2&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1566e2"]])

export default __exports__